import React from "react";
import { CustomButton } from "../index";
import { useNavigate } from "react-router-dom";
import "./FinalCTASection.css";

const FinalCTASection = () => {
  const navigate = useNavigate();
  return (
    <section className='final-cta'>
      <h2>Don’t Miss This Once-in-a-Lifetime Opportunity</h2>
      <p>
        Spaces are limited, and the whales are waiting. Secure your spot today.
      </p>
      <div className='booking-link-container'>
        <CustomButton
          text='Enquire Now'
          onClick={() =>
            navigate("/booking-enquiry", {
              state: {
                tour: {
                  whaleType: "Humpback",
                  country: "Tonga",
                },
              },
            })
          }
        />
      </div>
    </section>
  );
};

export default FinalCTASection;
